import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  Collapse,
  FormControlLabel,
  Button,
} from "@mui/material";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";

const GriGroup = ({
  seriesKey,
  groupKey,
  groupData,
  selectedPages,
  expandedSections,
  toggleSectionExpand,
  handleNestedParentCheckboxChange,
  handleNestedChildCheckboxChange,
}) => (
  <>
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={selectedPages[seriesKey].pages[groupKey]?.all || false}
            onChange={handleNestedParentCheckboxChange(seriesKey, groupKey)}
            sx={{
            //   color: "#1c486b",
              "&.Mui-checked": {
                color: "#1c486b",
              },
            }}
          />
        }
        label={groupData.label}
      />
      <Button
        onClick={() => toggleSectionExpand(groupKey)}
        size="small"
        sx={{ marginLeft: "-1.2rem" }}
        // endIcon={expandedSections[groupKey] ? <ExpandLess /> : <ExpandMore />}
      >
        {/* {expandedSections[groupKey] ? "Hide" : "Show"} */}
        <ExpandCircleDownIcon
          style={{
            transform: expandedSections[groupKey]
              ? "rotate(180deg)"
              : "rotate(0deg)",
            transition: "transform 0.3s ease",
            color: "#666666",
            fontSize: "1.2rem",
          }}
        />
      </Button>
    </Box>
    <Collapse in={expandedSections[groupKey]}>
      <Box sx={{ ml: 4 }}>
        {groupData.pages.map((pageKey) => (
          <FormControlLabel
            key={pageKey}
            control={
              <Checkbox
                checked={
                  selectedPages[seriesKey].pages[groupKey]?.pages?.[pageKey] ||
                  false
                }
                onChange={handleNestedChildCheckboxChange(
                  seriesKey,
                  groupKey,
                  pageKey
                )}
                sx={{
                //   color: "#1c486b",
                  "&.Mui-checked": {
                    color: "#1c486b",
                  },
                }}
              />
            }
            label={pageKey.replace(/_/g, "-").toUpperCase()}
          />
        ))}
      </Box>
    </Collapse>
  </>
);

export default GriGroup;
